import { Select } from '@nv/basic-components'
import { days, months, years } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import styles from './DateOfBirthDropdown.module.scss'

// NOTE: may make required a prop in future
export const DateOfBirthDropdown = ({ formik }: any) => {
  const { t } = useTranslation()
  return (
    <div className={styles['form__birth']}>
      <div className={styles['form__select-container']}>
        <div className={styles['form__item-title']}>
          {t('form.labels.dateOfBirth')} <span className={styles['form__required']}>*</span>
        </div>
        <div className={styles['form__selects']}>
          <Select
            placeholder={t('countdown.time.calendar.month')}
            formik={formik}
            options={months()}
            field='dobMonth'
            value={formik.values.dobMonth}
            isRequired={true}
            ariaLabel={t('registration.dateOfBirthMonth')}
            autoComplete='off'
          />
          <Select
            placeholder={t('countdown.time.calendar.day')}
            formik={formik}
            options={days}
            field='dobDay'
            value={formik.values.dobDay}
            isRequired={true}
            ariaLabel={t('registration.dateOfBirthDay')}
            autoComplete='off'
          />
          <Select
            placeholder={t('countdown.time.calendar.year')}
            formik={formik}
            options={years}
            field='dobYear'
            value={formik.values.dobYear}
            isRequired={true}
            ariaLabel={t('registration.dateOfBirthYear')}
            autoComplete='off'
          />
        </div>
      </div>
    </div>
  )
}
